
export const AccessibilityModal = () => `
    <div id="accessibility-modal" class="modal hidden">
        <style>
            /* Scoped styles for Accessibility Modal */
            /* Scoped styles for Accessibility Modal - Centered Style */
            #accessibility-modal {
                z-index: 20000 !important;
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(0, 0, 0, 0.5); /* Dim background */
                backdrop-filter: blur(5px);
            }
            
            #accessibility-modal .modal-content {
                position: relative;
                width: 400px;
                max-width: 90vw;
                background: rgba(20, 20, 20, 0.95);
                backdrop-filter: blur(20px);
                border: 1px solid rgba(255, 215, 0, 0.2);
                border-radius: 20px;
                box-shadow: 0 20px 60px rgba(0,0,0,0.9), 0 0 30px rgba(255, 215, 0, 0.1);
                color: #fff;
                font-family: 'Inter', sans-serif;
                overflow: hidden;
                pointer-events: auto;
                animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
            }

            @keyframes modalPop {
                from { 
                    opacity: 0; 
                    transform: scale(0) translate(100%, -100%); 
                }
                to { 
                    opacity: 1; 
                    transform: scale(1) translate(0, 0); 
                }
            }
            
            #accessibility-modal .modal-content {
                /* ... other styles ... */
                transform-origin: top right;
            }
            #accessibility-modal .modal-header {
                padding: 15px 20px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: rgba(0,0,0,0.2);
            }
            #accessibility-modal h2 {
                margin: 0;
                font-size: 1.4rem;
                color: #ffd700;
                text-transform: uppercase;
                letter-spacing: 1px;
                text-shadow: 0 2px 10px rgba(255, 215, 0, 0.3);
            }
            #accessibility-modal .close-btn {
                background: none;
                border: none;
                color: rgba(255,255,255,0.6);
                font-size: 2rem;
                cursor: pointer;
                transition: color 0.3s;
                line-height: 1;
            }
            #accessibility-modal .close-btn:hover {
                color: #fff;
            }
            #accessibility-modal .modal-body {
                padding: 30px 25px;
            }
            
            /* Modern Section */
            .acc-section {
                margin-bottom: 30px;
            }
            .acc-section:last-child {
                margin-bottom: 0;
            }
            .acc-label {
                display: block;
                font-size: 0.9rem;
                color: rgba(255,255,255,0.6);
                margin-bottom: 12px;
                font-weight: 600;
                letter-spacing: 0.5px;
            }
            
            /* Toggle Group */
            .acc-toggle-group {
                display: flex;
                gap: 10px;
                background: rgba(0,0,0,0.3);
                padding: 5px;
                border-radius: 10px;
                border: 1px solid rgba(255,255,255,0.1);
            }
            
            .acc-btn {
                flex: 1;
                padding: 12px 10px;
                background: transparent;
                border: none;
                border-radius: 8px;
                color: #aaa;
                cursor: pointer;
                transition: all 0.3s ease;
                font-size: 0.95rem;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                position: relative;
                overflow: hidden;
            }
            
            .acc-btn:hover {
                background: rgba(255, 255, 255, 0.05);
                color: #fff;
            }
            
            .acc-btn.active {
                background: linear-gradient(135deg, #ffd700, #b8860b);
                color: #000;
                font-weight: bold;
                box-shadow: 0 4px 15px rgba(255, 215, 0, 0.4);
            }
            
            /* Size Visuals */
            .size-preview {
                 font-weight: bold;
                 line-height: 1;
            }
            
            /* Icon Styling */
            .icon-pos {
                width: 18px;
                height: 18px;
                fill: currentColor;
                opacity: 0.8;
            }

            /* Hidden Selects (to maintain logic compatibility) */
            .hidden-select {
                display: none !important;
            }

        </style>

        <div class="modal-content" style="max-width: 450px;">
            <div class="modal-header">
                <h2>ERİŞİLEBİLİRLİK</h2>
                <button id="close-accessibility-btn" class="close-btn">&times;</button>
            </div>
            <div class="modal-body">
                <!-- Chat Size -->
                <div class="acc-section">
                    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">
                        <span class="acc-label" style="margin:0;">SOHBET YAZI BOYUTU</span>
                        <span id="chat-size-val" style="font-size:0.9rem; color:#ffd700; font-weight:bold;">16pt</span>
                    </div>
                    <div class="range-container" style="display:flex; align-items:center; gap:10px;">
                        <span style="font-size:0.8rem; color:#aaa;">A</span>
                        <input type="range" id="chat-size-range" min="10" max="40" step="1" value="16" style="width:100%; cursor:pointer;">
                        <span style="font-size:1.2rem; color:#fff;">A</span>
                    </div>
                </div>

                <!-- Chat Position -->
                <div class="acc-section">
                    <span class="acc-label">SOHBET PENCERESİ KONUMU</span>
                    <div class="acc-toggle-group" id="chat-pos-group">
                         <button class="acc-btn" data-val="left">
                            <span style="font-size:1.2rem;">⬅️</span> Sol
                        </button>
                        <button class="acc-btn" data-val="right">
                             Sağ <span style="font-size:1.2rem;">➡️</span>
                        </button>
                    </div>
                    <select id="chat-position-select" class="hidden-select">
                        <option value="right">Sağ</option>
                        <option value="left">Sol</option>
                    </select>
                </div>

                <!-- Scoreboard Size -->
                <div class="acc-section">
                    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">
                        <span class="acc-label" style="margin:0;">SKOR TABLOSU BOYUTU</span>
                        <span id="score-size-val" style="font-size:0.9rem; color:#ffd700; font-weight:bold;">14pt</span>
                    </div>
                    <div class="range-container" style="display:flex; align-items:center; gap:10px;">
                        <span style="font-size:0.8rem; color:#aaa;">123</span>
                        <input type="range" id="score-size-range" min="10" max="40" step="1" value="14" style="width:100%; cursor:pointer;">
                        <span style="font-size:1.2rem; color:#fff;">123</span>
                    </div>
                </div>
                
                <p style="font-size: 0.8rem; color: rgba(255,255,255,0.4); margin-top: 25px; text-align: center; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 15px;">
                    Ayarlar anlık olarak uygulanır.
                </p>
            </div>
        </div>
    </div>
`;
